// extracted by mini-css-extract-plugin
module.exports = {"cls1":"UserWorklistsPage-CssProp15_td-module--cls1--3xfEG","cls2":"UserWorklistsPage-CssProp15_td-module--cls2--p7pnJ UserWorklistsPage-CssProp15_td-module--cls1--3xfEG"};